const { path, test, compose } = require('ramda')

const self = {}

const getTargetClassNames = path([ 'target', 'className' ])
const isPikaClassName = test(/^pika/)
const comparisons = [ 'startDate', 'endDate' ]

self.getDateRange = function (obj) {
  return {
    startDate: obj.startDate,
    endDate: obj.endDate,
  }
}

self.rangeComparator = function (e1, e2, idx) {
  const i = idx === undefined ? 0 : idx
  const attrib = comparisons[i]
  if (i === comparisons.length) {
    return 0
  }
  if (e1[attrib] !== e2[attrib]) {
    return e1[attrib] < e2[attrib] ? -1 : 1
  }
  return self.rangeComparator(e1, e2, i + 1)
}

self.descendingRangeComparator = function (e1, e2, i) {
  return self.rangeComparator(e1, e2, i) * -1
}

self.isPikadayEvent = compose(isPikaClassName, getTargetClassNames)

module.exports = self
